module.exports = __webpack_public_path__ + "static/media/elham.eadf90a5.jpeg";